import { CompactPricingComponent } from './CompactPricingComponent';

/**
 * Campaign variant B. Was a bare re-export of {@link CompactPricingComponent}
 * — it had to become a real wrapper to opt into the campaign price typography
 * (SH-415), since setting it on the shared component would have changed
 * variant A too.
 */
export function CompactPricingComponentB(
  props: React.ComponentProps<typeof CompactPricingComponent>,
) {
  return <CompactPricingComponent {...props} campaignPricing />;
}
